import { createContext } from "react";
//try to use context api
export const NoteContext=createContext();

export default NoteContext;
